export default "__VITE_ASSET__CM1RJ2Fo__"